module.exports = __webpack_public_path__ + "img/hero-image.08d7cbb0.webp";